import { PATHS } from '@belong/common';
import { Link, Text } from '@belong/ui';
import { clsx } from 'clsx';
import { AUTH_STRINGS } from 'src/features/auth/strings';

type Props = {
  variant?: 'primary' | 'secondary';
};

export function AgreeToTerms({ variant = 'primary' }: Props) {
  return (
    <>
      <Text
        className={clsx(
          'text-center',
          variant === 'secondary' ? 'text-dark-gray' : '',
        )}
        variant="p1"
      >
        {AUTH_STRINGS['terms.first.line']}
      </Text>
      <Text
        as="span"
        className={clsx(
          'text-center',
          variant === 'secondary' ? 'text-dark-gray' : '',
        )}
        variant="p1"
      >
        <Link href={PATHS.PRIVACY_POLICY} target="_blank" variant="text">
          <Text
            fontWeight="semibold"
            variant="p1"
            className={variant === 'secondary' ? 'text-dark-gray' : ''}
          >
            {AUTH_STRINGS['terms.privacy']}
          </Text>
        </Link>{' '}
        {AUTH_STRINGS['terms.and']}{' '}
        <Link href={PATHS.TERMS} target="_blank" variant="text">
          <Text
            fontWeight="semibold"
            variant="p1"
            className={variant === 'secondary' ? 'text-dark-gray' : ''}
          >
            {AUTH_STRINGS['terms.tos']}
          </Text>
        </Link>
      </Text>
    </>
  );
}
